webpackJsonp([162114328119038],{

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(259);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(337),
	    baseIsNaN = __webpack_require__(773),
	    strictIndexOf = __webpack_require__(835);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),

/***/ 773:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),

/***/ 785:
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(258);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),

/***/ 835:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(257),
	    baseFilter = __webpack_require__(260),
	    baseIteratee = __webpack_require__(108),
	    isArray = __webpack_require__(23);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(769),
	    isArrayLike = __webpack_require__(71),
	    isString = __webpack_require__(847),
	    toInteger = __webpack_require__(196),
	    values = __webpack_require__(855);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),

/***/ 847:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(69),
	    isArray = __webpack_require__(23),
	    isObjectLike = __webpack_require__(72);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(785),
	    keys = __webpack_require__(109);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(28);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _get = __webpack_require__(41);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _index = __webpack_require__(35);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _BlogMenu = __webpack_require__(83);
	
	var _BlogMenu2 = _interopRequireDefault(_BlogMenu);
	
	var _BlogPostExcerpt = __webpack_require__(59);
	
	var _BlogPostExcerpt2 = _interopRequireDefault(_BlogPostExcerpt);
	
	var _ResponsiveGrid = __webpack_require__(15);
	
	var _ReadMoreButton = __webpack_require__(36);
	
	var _ReadMoreButton2 = _interopRequireDefault(_ReadMoreButton);
	
	var _map = __webpack_require__(73);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _filter = __webpack_require__(263);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _startCase = __webpack_require__(195);
	
	var _startCase2 = _interopRequireDefault(_startCase);
	
	var _includes = __webpack_require__(844);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toList = ['web', 'arduino', 'iot', 'laravel', 'hydroponie', 'quick-tips', 'javascript'];
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Atrakeur-Page' },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement('meta', { charSet: 'utf-8' }),
	        _react2.default.createElement(
	          'title',
	          null,
	          'Atrakeur: DIY, Modelisme et Web'
	        )
	      ),
	      _react2.default.createElement(_index2.default, {
	        contentText: '<h1>' + (0, _get2.default)(data, 'contentfulCategory.title') + '</h1>',
	        contentImage: (0, _get2.default)(data, 'contentfulCategory.featuredImage.resolutions'),
	        size: 'medium' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'Atrakeur-Content' },
	        _react2.default.createElement(_BlogMenu2.default, null),
	        (0, _map2.default)((0, _filter2.default)(data.allContentfulBlogPost.edges, function (node) {
	          return node.node.category.id === data.contentfulCategory.id;
	        }), function (_ref2, index) {
	          var post = _ref2.node;
	          return _react2.default.createElement(_BlogPostExcerpt2.default, { post: post, inverted: index % 2 == 1, key: post.id });
	        }),
	        _react2.default.createElement(
	          _ResponsiveGrid.ResponsiveContainer,
	          { className: 'Atrakeur-BlogPost-Tags' },
	          _react2.default.createElement(
	            _ResponsiveGrid.Cell,
	            { colSpanDesktop: '6', colSpanTablet: '4', colSpanMobile: '4', withPadding: true, withMarginHor: true, white: true },
	            'Sujets principaux: ',
	            (0, _map2.default)((0, _get2.default)(data, 'allContentfulTag.edges'), function (tag) {
	              return (0, _includes2.default)(toList, tag.node.slug) && _react2.default.createElement(
	                _ReadMoreButton2.default,
	                { to: '/blog/tag-' + tag.node.slug },
	                (0, _startCase2.default)(tag.node.name)
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-js-697a40035ecc068be6da.js